
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function curry<T extends(...args: any[]) => any>
(this: unknown, fn: T, ...args: Partial<Parameters<T>>) {
    return fn.bind(this, ...args);
}
